module.exports = __webpack_public_path__ + "img/preview.30f9868b.webp";